// extracted by mini-css-extract-plugin
export default {"fieldContainer":"EditCategoryGroupModal_fieldContainer__6Dl88","label":"EditCategoryGroupModal_label__j7VlH"};